(function () {
  var HEADER_OFFSET = 96;
  var TARGET_IDS = {
    'system-components': true,
    ProductsList: true,
    'system-resources': true,
  };

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resolveTargetId(id) {
    if (id === 'ProductsList' && document.getElementById('system-components')) {
      return 'system-components';
    }
    return id;
  }

  function scrollToSection(id, updateHash) {
    var targetId = resolveTargetId(id);
    var target = document.getElementById(targetId);
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
    if (updateHash && history.replaceState) {
      history.replaceState(null, '', '#' + targetId);
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    var id = href.slice(hashIndex + 1).split('?')[0];
    if (!TARGET_IDS[id]) return;
    if (!document.getElementById(resolveTargetId(id))) return;
    var linkUrl = new URL(link.href, window.location.href);
    if (linkUrl.pathname !== window.location.pathname) return;
    event.preventDefault();
    scrollToSection(id, true);
  });

  if (window.location.hash) {
    var initialId = window.location.hash.replace('#', '');
    if (TARGET_IDS[initialId] && document.getElementById(resolveTargetId(initialId))) {
      window.setTimeout(function () {
        scrollToSection(initialId, false);
      }, 50);
    }
  }
})();
